import { light } from "@/services/light";
import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { setUser } from "@sentry/react";

export const sentryMiddleware = createListenerMiddleware();

sentryMiddleware.startListening({
  matcher: isAnyOf(
    light.endpoints.getAccount.matchFulfilled,
    light.endpoints.getAccount.matchRejected,
  ),
  effect: (action) => {
    if (light.endpoints.getAccount.matchFulfilled(action)) {
      setUser({ id: action.payload.uuid, email: action.payload.email });
    }
    if (light.endpoints.getAccount.matchRejected(action)) {
      setUser(null);
    }
  },
});
